// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Toaster_wrapper__3Ggw_"};